import React from 'react';
import { Button, Form } from 'semantic-ui-react';
import { Field, reduxForm, reset } from 'redux-form';
import { connect } from 'react-redux';
import { required, number } from '../../../../../../../lib/FormValidators';
import PhotoBoothModal from '../../../../../../../containers/PhotoBoothModal';
import { Tech3Input } from '../../../../../../../components/FormElements';
import { closeAllModals } from '../../../data/fileImport/modalActions';
import { getWorkerConfiguration, updateWorkerConfiguration } from '../../../data/fileImport/workerActions';

const workerFormName = 'WorkerFormModal';

class WorkerForm extends React.Component {
  constructor(props) {
    super(props);
    this.submitWorkerForm = this.submitWorkerForm.bind(this);
    this.state = { parameters: [] };
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen && this.props.project) {
      this.props.dispatch(getWorkerConfiguration(this.props.project.id, config => {
        this.setState({parameters: config});
        this.state.parameters.forEach(worker => {
          worker.values.forEach(parameter => {
            this.props.change("id".concat(parameter.id), parameter.value);
          })
        })
      }));
    }
    if (prevProps.isOpen && !this.props.isOpen) {
      this.props.dispatch(reset(workerFormName));
    }
  }

  submitWorkerForm(values) {
    this.props.dispatch(updateWorkerConfiguration(this.props.project.id, values))
  
    // Close modal
    this.props.dispatch(closeAllModals());
  }

  render() {
    return (
      <PhotoBoothModal {...this.props}>
        <Form
          className="WorkerFormModal"
          onSubmit={this.props.handleSubmit(this.submitWorkerForm)}>
          <h2>Configure workers</h2>
          {this.state.parameters.map((parameterGroup, value) => {
            return (
              <div key={value} className="worker-parameter-group">
                <h3>{parameterGroup.worker}</h3>
                <div className="worker-parameter-field">
                  {parameterGroup.values.map((parameter, otherValue) => (
                    <Field
                      key={`${value}_${otherValue}`}
                      label={parameter.name}
                      name={"id".concat(parameter.id)}
                      type="text"
                      component={Tech3Input}
                      validate={[required, number]}
                    />
                  ))}
                </div>
              </div>
          )})}
          <Button type="submit" disabled={!this.props.valid}>
            Submit
          </Button>
        </Form>
      </PhotoBoothModal>
    );
  }
};

const workerForm = reduxForm({
  form: workerFormName,
  enableReinitialize: true
})(WorkerForm);

export default connect(state => ({
  session: state.projects.single.fileImport.sessions.find(
    session => session.id === state.projects.single.fileImport.modals.workerForm.dataTreeId
  ),
  sessions: state.projects.single.fileImport.sessions,
  initialValues: state.projects.single.fileImport.intialValuesLogSessionForm
}))(workerForm);




// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/fileImport/modals/WorkerForm.js